// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactSVG from 'react-svg';
import { isMobile, CustomView, isMobileOnly } from 'react-device-detect';

import SubHeader from '../../components/SubHeader';
import SearchBar from '../../components/SearchBar';
import Loader from '../../components/Loader';
import ResultCard from '../../components/ResultCard';
import FacetFilter from '../../components/FacetFilter';
import PaginationResults from '../../components/PaginationResults';
import { svgStyle } from '../../components/ComboFilter/style';

import { Wrapper } from './style';
import ChevronOuvre2 from '../../assets/images/chevron2_off.svg';
import { makeSearch } from '../../actions/search';

import type { Document } from '../../types/Document';
import CloseIcon from '../../assets/images/close.svg';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../CurrentLocale';

import NoDocIcon from '../../assets/images/no_doc.png';

type Props = {
  loading: boolean,
  documents: Array<Document>,
  makeSearch: () => void,
  counts: Object
};

type State = {
  displaySidebar: boolean,
  screenWidth: ?number
};

class Result extends Component<Props, State> {
  state = {
    displaySidebar: !isMobile,
    screenWidth: null
  };

  componentDidMount() {
    this.updateDimensions();
    this.props.makeSearch();
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      screenWidth: Math.max(
        //$FlowFixMe
        document.documentElement.clientWidth,
        window.innerWidth || 0
      )
    });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  handleTogglSideBar = () => {
    this.setState({ displaySidebar: !this.state.displaySidebar });

    window.scrollTo(0, 0);
  };

  haveFacets = () => {
    const { counts } = this.props;

    return Object.keys(counts).length !== 0;
  };

  render() {
    const { displaySidebar, screenWidth } = this.state;
    const { loading, documents } = this.props;

    if (!screenWidth) return null;

    const columns = {};

    let nbColumn;
    if (screenWidth < 700) nbColumn = 1;
    else if (screenWidth < 1024) nbColumn = 2;
    else if (screenWidth < 1367) nbColumn = displaySidebar ? 2 : 3;
    else nbColumn = displaySidebar ? 3 : 4;

    let i = 1;
    documents.forEach(document => {
      if (!columns[`column${i}`]) columns[`column${i}`] = [];
      columns[`column${i}`].push(
        <ResultCard key={document.url} {...document} />
      );

      if (i >= nbColumn) i = 1;
      else i += 1;
    });

    return (
      <Wrapper>
        {loading && <Loader />}
        <SubHeader title={formatMessage({ id: 'result.search_doc' })} />
        <div className="container">
          <SearchBar />
        </div>
        <div className="root-container">
          <div className="result-header">
            {this.haveFacets() && (
              <div className="header">
                <div className="text">
                  <FormattedMessage id="result.select_filters" />
                </div>
                <div className="icon-sidebar" onClick={this.handleTogglSideBar}>
                  <div
                    className="icon-sidebar--anim"
                    style={{
                      transform:
                        screenWidth < 1366
                          ? 'rotate(0deg)'
                          : displaySidebar
                            ? 'rotate(-90deg)'
                            : 'rotate(90deg)'
                    }}
                  >
                    <ReactSVG svgStyle={{ width: 20 }} src={ChevronOuvre2} />
                  </div>
                </div>
              </div>
            )}
            <div className="result-pagination">
              {documents.length !== 0 && (
                <PaginationResults screenWidth={screenWidth} />
              )}
            </div>
          </div>

          <div className="result-container">
            {this.haveFacets() && (
              <div
                className="facet-zone"
                style={{
                  display: displaySidebar ? 'block' : 'none',
                  zIndex: isMobileOnly ? 101 : 'initial'
                }}
              >
                <CustomView condition={screenWidth <= 1024}>
                  <div
                    className="close-filters"
                    onClick={this.handleTogglSideBar}
                  >
                    <div>
                      <FormattedMessage id="result.filters" />
                    </div>
                    <ReactSVG svgStyle={svgStyle} src={CloseIcon} />
                  </div>
                </CustomView>
                <FacetFilter />
              </div>
            )}

            <div className="result-zone">
              {documents.length === 0 ? (
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: 24,
                    borderTop: '1px solid #F8AE37',
                    marginLeft: 20,
                    marginRight: 20
                  }}
                >
                  <br /> <br />
                  <img
                    src={NoDocIcon}
                    alt={formatMessage({ id: 'result.no_document_found' })}
                  />
                  <br /> <br />
                  <FormattedMessage id="result.no_document_found" />
                  <br />
                  <FormattedMessage id="result.please_try_again" />
                  <br /> <br />
                </div>
              ) : (
                <React.Fragment>
                  <div className="results">
                    {Object.values(columns).map((column, index) => (
                      //$FlowFixMe
                      <div
                        style={{ width: `calc(100% / ${nbColumn})` }}
                        key={index}
                      >
                        {column}
                      </div>
                    ))}
                  </div>

                  <div className="result-pagination">
                    <PaginationResults
                      screenWidth={screenWidth}
                      onlyPagination={isMobile}
                      paddingTop={51}
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ results, facets }) => ({
  documents: results.documents,
  loading: results.loading || facets.loading,
  counts: facets.counts
});

export default connect(
  mapStateToProps,
  {
    makeSearch
  }
)(Result);



// WEBPACK FOOTER //
// ./src/pages/Result/index.js